const getPortalVariable = key => {
  if (typeof window.SSR_HEADER === 'undefined') return null;

  return window.SSR_HEADER[key];
};

export default getPortalVariable;
